/**
 * Employee Dashboard — el empleado aterriza en su trabajo real (BHM-CLD-REQ-028).
 */
import MiTrabajoPage from './MiTrabajoPage';

export default function EmployeeDashboardPage() {
  return <MiTrabajoPage />;
}
